import React from 'react';
import { List } from 'basis';
import styled from '@emotion/styled';
import { PRODUCT_CODE_DAVID_JONES_PREMIERE, PRODUCT_CODE_DAVID_JONES_PRESTIGE } from '_config';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { EarnRateDisclaimerContent } from './Disclaimer';

const Wrapper = styled.div`
  ul {
    padding-left: 1em;
  }

  li {
    &::before {
      width: 0.3em;
      height: 0.3em;
      left: -1em;
      line-height: 24px;
    }

    &:not(:first-of-type) {
      margin-top: 0;
    }
  }
`;

export function EarnRateTiers({ productCode, showDisclaimer = false }) {
  const flags = useFlags();
  const isDjCvpV2 = flags?.djCvpV2 || false;
  const djEarnRate = {
    [PRODUCT_CODE_DAVID_JONES_PREMIERE]: isDjCvpV2
      ? ['2 points per $1 spent at David Jones', '1 point per $1 spent everywhere else.']
      : [
          '2 points per $1 spent at David Jones',
          '3 points per $1 spent at participating petrol stations & supermarkets',
          '1 point per $1 spent everywhere else.',
        ],
    [PRODUCT_CODE_DAVID_JONES_PRESTIGE]: isDjCvpV2
      ? ['3 points per $1 spent at David Jones', '1 point per $1 spent everywhere else']
      : [
          '4 points per $1 spent at David Jones',
          '3 points per $1 spent at participating petrol stations & supermarkets',
          '1 point per $1 spent everywhere else',
        ],
  };

  return (
    <Wrapper>
      <List>
        {djEarnRate[productCode]?.map(rate => (
          <List.Item key={rate}>{rate}</List.Item>
        ))}
        {showDisclaimer && (
          <List.Item>
            <EarnRateDisclaimerContent productCode={productCode} />
          </List.Item>
        )}
      </List>
    </Wrapper>
  );
}
